import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole, type AppRole } from "@/hooks/useUserRole";

interface Props {
  allowedRoles: AppRole[];
  children: JSX.Element;
}

export const RoleProtectedRoute = ({ allowedRoles, children }: Props) => {
  const { session, loading: authLoading } = useAuth();
  const { hasAny, loading: roleLoading } = useUserRole();

  if (authLoading || roleLoading) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        Checking access…
      </div>
    );
  }

  if (!session) return <Navigate to="/auth" replace />;
  if (!hasAny(allowedRoles)) return <Navigate to="/access-denied" replace />;

  return children;
};
